module.exports = __webpack_public_path__ + "img/50-1.6017837b.svg";